const translations = {
    caution: 'Caution'
};

export default translations;
